/* eslint-disable */

import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
export default {
  components: {
    customModal
  },
  props: {
    fieldName: {
      type: String,
      required: true
    },
    tableName: {
      type: String,
      required: true
    },
    recordId: {
      type: [String],
      required: true
    }
},
data() {
  return {
    auditData: [],
    loading: false,
    baseapi: process.env.VUE_APP_Service_URL,
  };
},
mounted() {
  this.getAuditData();
},
methods: {
  async getAuditData() {
    try {
      this.loading = true;
      const token = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/management/audit/getfieldhistory`,
        {
          params: {
            recordId: this.recordId,
            field: this.fieldName,
            auditTable: this.tableName
          },
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

      this.auditData = res.data || [];

    } catch (err) {
      console.error("Audit API Error:", err);
    } finally {
      this.loading = false;
    }
  },
   formatDate(date) {
    if (!date) return "-";
    return new Date(date).toLocaleString(); // shows date + time
  }
}
};